var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.04115 11.4857C0.870034 11.6568 0.870034 11.9991 1.04115 12.1702L1.09819 12.2272L6.63088 15.4784L12.5628 11.1435L8.22794 17.0754L11.4791 22.6081C11.5932 22.8363 11.9354 22.9504 12.1636 22.8363C12.2206 22.7792 12.3347 22.6652 12.3917 22.6081L17.6392 6.86562C17.6963 6.58043 17.5822 6.35228 17.354 6.23821C17.24 6.23821 17.1259 6.23821 17.0118 6.23821L1.2693 11.3716C1.15522 11.3716 1.09819 11.4287 1.04115 11.4857Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendLogo);
export default __webpack_public_path__ + "static/media/sendLogo.7a477cb534d03cad7c253193c8e9549b.svg";
export { ForwardRef as ReactComponent };